'use client';

import { FC } from 'react';

import { NormalizedTechnology } from '@ravago/shared/page-data/models/contentful-mapped';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Divider } from '@ravago/shared/radiance/components/divider/components/Divider/Divider';
import { ListItem } from '@ravago/shared/radiance/components/list/components/ListItem/ListItem';

import { ConsumerWrapper } from '../../consumer-wrapper/consumer-wrapper';
import { DynamicPageLink } from '../../dynamic-page-link/dynamic-page-link';
import { MockLink } from '../../mock-link/mock-link';

interface Props {
   technologies: Array<NormalizedTechnology>;
   baseRoute?: string;
   isConsumer: boolean;
   locale: string;
}

const TechnologyListItem = ({ technology, baseRoute }: { technology: NormalizedTechnology; baseRoute?: string }) => (
   <ListItem interactive={false} trailingIcon={baseRoute ? 'chevron-right' : ''} supportingTextVariant="small" variant="transparent">
      {technology.name}
   </ListItem>
);

export const TechnologyItemList: FC<Props> = ({ technologies, baseRoute, isConsumer, locale }) => (
   <Box direction="column" gap="none">
      {technologies
         ?.sort((a1, a2) => (a1.name ?? '').localeCompare(a2.name ?? ''))
         .filter((technology) => technology)
         .map((technology, index) => (
            <div data-test-selector="360technology" key={technology.id} style={{ display: 'contents' }}>
               {index > 0 && <Divider />}
               <ConsumerWrapper
                  isConsumer={isConsumer}
                  renderConsumer={(children) => (
                     <DynamicPageLink
                        id={`dynamic-link__technology-item-list__${technology.slug}`}
                        slug={technology.slug}
                        baseRoute={{ url: baseRoute, noFollow: technology.seoMetadata?.noFollow }}
                        locale={locale}
                        underline="none"
                     >
                        {children}
                     </DynamicPageLink>
                  )}
                  renderProducer={(children) => <MockLink>{children}</MockLink>}
               >
                  <TechnologyListItem technology={technology} baseRoute={baseRoute} />
               </ConsumerWrapper>
            </div>
         ))}
   </Box>
);
